module.exports = __webpack_public_path__ + "img/logo-white-square.6b79f09c.svg";